import React, { useCallback, useMemo } from "react";
import { Grid, IconButton, Switch, TableCell, TextField, Tooltip, Typography } from "@mui/material";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper";
import MainNavbar from "../../../components/Navbars/MainNavbar";
import JamezzTableV2, { useReloadState } from "../../../components/JamezzTable/V2/JamezzTableV2";
import FormElement from "../../../components/JamezzTable/FormElement";
import { Link } from "react-router";
import Edit from "@mui/icons-material/Edit";
import { useDialog } from "../../../licensing/utils/DialogProvider";
import useJTFilter from "../../../components/JamezzTable/V2/useJTFilter";
import { Add, Delete, FreeBreakfast, Lock } from "@mui/icons-material";
import VestigingFilterV2, { getVestigingFilterState } from "../../../components/VestigingFilter/VestigingFilter";
import { connect } from "react-redux";
import GridContainer from "../../../components/Grid/GridContainer";
import GridItem from "../../../components/Grid/GridItem";
import AuthenticationWrapper from "../../../auth/AuthenticationWrapper";
import Button from "../../../components/CustomButtons/Button";
import AreYouSureDialog from "../../../components/Dialogs/AreYouSureDialog";
import { _post } from "../../../http";
import { unwrap } from "../../../unwrap";

const endPoint = "core/packagings";

function Packagings(props) {
  const { reloadState, updateReloadState } = useReloadState();
  const [textField, searchFilter] = useJTFilter("name");

  const [openDialog] = useDialog();
  const renderHeaderCells = useCallback(
    () => [
      { id: "id", label: "#", numeric: true, disablePadding: false, sortable: true },
      {
        id: "name",
        label: <TranslationWrapper tDefault={"Packaging name"} tKey={"packagings.name"} />,
        numeric: false,
        disablePadding: false,
        sortable: true,
      },
      {
        id: "Enabled",
        label: <TranslationWrapper tDefault={"Is enabled?"} tKey={"packagings.enabled"} />,
        numeric: false,
        disablePadding: false,
        sortable: true,
      },
    ],
    []
  );

  const renderRowCells = useCallback((row, isEditable) => {
    return (
      <>
        <TableCell align={"right"} style={{ width: 100 }}>
          {row.id}
        </TableCell>
        <TableCell>
          {isEditable ? (
            <FormElement endPoint={endPoint} name={"name"} row={row}>
              <TextField size={"small"} variant={"standard"} />
            </FormElement>
          ) : null}
          {!isEditable ? row.name : null}
        </TableCell>
        <TableCell>
          {isEditable ? (
            <FormElement endPoint={endPoint} name={"enabled"} parseBoolToInt={true} row={row} valueKey={"checked"}>
              <Switch size={"small"} variant={"standard"} />
            </FormElement>
          ) : null}
          {!isEditable ? <Switch checked={row.enabled} onChange={() => {}} size={"small"} /> : null}
        </TableCell>
      </>
    );
  }, []);

  const renderSelectionActions = useCallback((selected) => {
    return (
      <Tooltip title={<TranslationWrapper tKey={"Delete"} />}>
        <IconButton
          onClick={() => {
            openDialog({
              children: (
                <AreYouSureDialog
                  content={<TranslationWrapper tKey={"Are you sure you want to delete the selected?"} />}
                  onOk={() => {
                    _post(`${endPoint}/multipledelete`, { ids: selected }).then(() => {
                      updateReloadState();
                    });
                  }}
                />
              ),
            });
          }}
          style={{ color: "lightcoral" }}
        >
          <Delete />
        </IconButton>
      </Tooltip>
    );
  }, []);

  const renderRowActions = useCallback((row) => {
    return (
      <TableCell align={"right"}>
        <Link to={`./${row.id}/edit`}>
          <Tooltip
            placement={"bottom"}
            title={<TranslationWrapper tDefault={"Edit"} tKey={"global.jamezzTable.edit"} />}
          >
            <IconButton color={"primary"} simple size={"small"}>
              <Edit />
            </IconButton>
          </Tooltip>
        </Link>
      </TableCell>
    );
  }, []);

  const filters = useMemo(() => {
    let filters = {};
    if (searchFilter) {
      filters = searchFilter;
    }
    if (props.filters) {
      filters = { ...filters, ...props.filters };
    }
    return filters;
  }, [searchFilter, props.filters]);

  const salesarea = unwrap(props.vestiging_id);
  const appTarget = unwrap(props.appTarget);

  return (
    <div>
      <MainNavbar paginaTitel={<TranslationWrapper tDefault={"Packagings"} tKey={"packagings.table.title"} />} />

      <GridContainer>
        <GridItem xs={12}>
          {salesarea ? (
            <AuthenticationWrapper
              child={
                <Link to={"./create"}>
                  <Button color={"success"}>
                    <Add />{" "}
                    <TranslationWrapper tDefault={"Create new packaging"} tKey={"packagings.createNewPackaging"} />
                  </Button>
                </Link>
              }
              permissionKey={"packagings.create"}
            />
          ) : (
            <Typography>
              <Lock />
              <TranslationWrapper tKey={"Only supported in appv5"} />
            </Typography>
          )}
        </GridItem>
      </GridContainer>

      <VestigingFilterV2 />
      {textField}
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <JamezzTableV2
            checkboxSelection={true}
            dense={true}
            endPoint={endPoint}
            filters={filters}
            headerIcon={<FreeBreakfast />}
            reloadState={reloadState}
            renderCellsForRow={renderRowCells}
            renderHeaderCells={renderHeaderCells}
            renderRowActions={renderRowActions}
            renderSelectionActions={renderSelectionActions}
            tableTitle={<TranslationWrapper tDefault={"Packagings"} tKey={"packagings.table.title"} />}
            uuid={"Packagings-diu1j209jd89jsx"}
          />
        </Grid>
      </Grid>
    </div>
  );
}

const mapStateToProps = (state) => {
  let filters = getVestigingFilterState(state, true);

  return {
    filters,
    vestiging_id: state.filtersV2.vestiging_id?.value,
    appTarget: state.filtersV2.vestiging_id?.appTarget,
  };
};

export default connect(mapStateToProps)(Packagings);
